import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './locales/de.json';

/** German only in the MVP; all texts live in locale files (WEB-010). */
export const defaultNS = 'translation';
export const resources = { de: { translation: de } } as const;

void i18n.use(initReactI18next).init({
  lng: 'de',
  fallbackLng: 'de',
  resources,
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
